export function isSeoUserAgent(userAgent: string): boolean {
  const userAgentResolved: string = userAgent.toLowerCase();
  return [
    // search engine bots
    'googlebot',
    'google-inspectiontool',
    'bing',
    'yandex',
    // LLM/AI bots BCF-4882
    'gptbot',
    'chatgpt-user',
    'claudebot',
    'perplexitybot',
    'perplexity-user',
    'google-extended',
    'prerender'
  ].some((bot: string) => userAgentResolved.includes(bot));
}

export function isSeoUserAgentFromNavigatorGlob(): boolean {
  const userAgent: string = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  return isSeoUserAgent(userAgent);
}
